import { resolveClassId } from "../catalogs/characterSystemCatalog";

class CharacterClass {
  constructor(json) {
    this.id = resolveClassId(json.id || json.name);
    this.classLevel = Number(json.classLevel);
    this.availableWeapons = json.availableWeapons;
    this.availableArmor = json.availableArmor;
  }
}

export default CharacterClass;
